import * as React from 'react'
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from '../../library/types/ISystemBase';
import { SystemBase } from '../../library/common/SystemBase';
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';


interface ISystemNumberInput  {
    minValue?: number,              // minimum length of the input
    maxValue?: number,              // maximum length of the input
}

/**
 * Creates an Input with Label  
 * */
export default class SystemNumberInput extends SystemBase<ISystemNumberInput>
{

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <this.WrapperDiv>
                <NumericTextBox
                    id={this.props.id}
                    name={this.props.name}
                    required={this.props.isRequired}
                    value={this.state.value}
                    className="form-control"
                    disabled={this.props.disabled}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    min={this.props.minValue}
                    max={this.props.maxValue}
                    format='#'
                />
            </this.WrapperDiv>
        );
    }
}
